import Vue from 'vue'
import App from '@/App'
import { router } from '@/components/router'
import store from '@/store/index'
import util from '@/util/index'
import ctrl from '@/common/controller'
import Antd from 'ant-design-vue'

Vue.use(Antd)

Vue.prototype.$util = util
Vue.prototype.$ctrl = ctrl

Vue.config.productionTip = false

new Vue({
    render: (h) => h(App),
    router,
    store,
    util,
    ctrl
}).$mount('#app')
